import { PageType } from "@/types";
import { Float } from "@react-three/drei";
import { useSpring } from "framer-motion";
import { ReactNode } from "react";

export const FloatAnimation = ({ page, isAnimating, children }: { page: PageType; isAnimating: boolean; children: ReactNode }) => {
	const floatSpeed = page.floatAnimation?.speed || 1;

	// const animatedSpeed = useSpring(isAnimating ? floatSpeed : 0, { stiffness: 0, damping: 10 });

	if (!page.floatAnimation) {
		return <>{children}</>;
	}

	return (
		<>
			<Float
				enabled={true}
				scale={1}
				rotation={[0, 0, 0]}
				speed={floatSpeed}
				rotationIntensity={page.floatAnimation.rotationIntensity}
				floatIntensity={1}
				floatingRange={[page.floatAnimation.floatingRange.min, page.floatAnimation.floatingRange.max]}
			>
				{children}
			</Float>
		</>
	);
};
